import axios from 'axios'
import { Dialog, Toast } from 'vant'
import { getStore } from '@/utils/index'

// 超时时间
axios.defaults.timeout = 30000
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true

// HTTPrequest拦截
axios.interceptors.request.use(config => {
  const token = getStore('token')
  const APPCLICATION_CODE = getStore('APPCLICATION_CODE')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + getStore('token') // 让每个请求携带token
  }
  if (APPCLICATION_CODE) {
    config.headers['APPCLICATION_CODE'] = APPCLICATION_CODE
  }
  return config
}, error => {
  return Promise.reject(error)
})

// HTTPresponse拦截
axios.interceptors.response.use(data => {
  if (data.data.code !== 200) {
    Toast({
      message: data.data.message || '请求失败，稍后重试'
    })
  }
  return data
}, error => {
  if (error.response) {
    console.log('error')
    console.log(error.response)
    const msg = error.response.message || '请求失败，稍后重试'
    if (error.response.status === 500) {
      Toast({
        message: msg
      })
    } else if (error.response.status === 401) {
      Dialog({
        message: error.response.data.message
      })
    } else {
      Toast({
        message: msg
      })
    }
  }
  return Promise.reject(new Error(error))
})

export default axios
